/**
 * Help article URLs for Demand Response events
 */
export const VEHICLE_DR_EVENT_HELP_URL =
  'https://optiwatt.zendesk.com/hc/en-us/articles/44087312433179-What-should-I-expect-for-my-EV-during-Demand-Response-events'
